import React, { useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import PropTypes from 'prop-types'

import {
  Flex,
  FlexItem,
  TEXT_VARIANT_LIGHT,
  Button,
  BUTTON_VARIANT_PRIMARY,
  InputText,
  INPUT_TEXT_VARIANT_DANGER,
  FormElement,
  ChipCheckbox
} from 'mailup-web-components'
import { regexEmail } from 'mailup-react-helpers'
import { StyledLabel } from '../../SelectRecipient'


export const InputEmail = ({ lastEmails, searchRecipientsCallback }) => {
  const intl = useIntl()
  const [email, setEmail] = useState('')
  const [error, setError] = useState(null)
  const [lastEmailsSelected, setLastEmailsSelected] = useState(lastEmails)
  const [lastEmailsList, setLastEmailsList] = useState(lastEmails)

  const handleChange = e => {
    const newEmail = e.target.value
    setEmail(newEmail)

    if (newEmail.length > 0 && !regexEmail.test(newEmail)) {
      setError(
        intl.formatMessage({
          id: 'Load.Common.WrongFormatWarning'
        })
      )
    } else {
      setError(false)
    }
  }

  const selectEmail = email => {
    const listEmail = [
      {
        value: email.value,
        selected: true
      }
    ]

    lastEmails.map(e => {
      if (e.value !== email.value) {
        listEmail.push({
          value: e.value,
          selected: false
        })
      }
    })

    setLastEmailsSelected(listEmail)
    setEmail(email.value)
    setError(false)
  }

  useEffect(() => {
    if (lastEmails && lastEmails.length > 0) {
      setLastEmailsSelected(lastEmails)

      const emailsList = []
      lastEmails.forEach(email => emailsList.push(email.value))
      setLastEmailsList(emailsList)

      const emails = lastEmails.filter(email => email.selected)
      if (emails && emails.length > 0) {
        selectEmail(emails[0])
        intSearchRecipient(emails[0].value)
      }
    }
  }, [lastEmails])

  const handleApply = selectedEmail => {
    if (!regexEmail.test(selectedEmail)) {
      setError(
        intl.formatMessage({
          id: 'Load.Common.WrongFormatWarning'
        })
      )
    } else {
      searchRecipient(selectedEmail)
    }
  }

  const searchRecipient = selectedEmail => {
    const emails = [selectedEmail]
    lastEmailsList.forEach(email => {
      if (selectedEmail !== email && emails.length < 3) {
        emails.push(email)
      }
    })

    setLastEmailsList(emails)

    searchRecipientsCallback(
      { email: selectedEmail },
      {
        lastEmails: [...emails],
        lastTypeSelected: 'email'
      },
      []
    ).then(res => {
      if (res.Items.length === 0) {
        setError(
          intl.formatMessage({
            id: 'Load.PreviewViewer.ErrorEmailRecipient'
          })
        )
      } else {
        setError(null)
      }
    })
  }

  const intSearchRecipient = selectedEmail => {
    searchRecipientsCallback({ email: selectedEmail }, null, []).then(res => {
      if (res.Items.length === 0) {
        setError(
          intl.formatMessage({
            id: 'Load.PreviewViewer.ErrorEmailRecipient'
          })
        )
      } else {
        setError(null)
      }
    })
  }

  return (
    <Flex flexDirection='column' margin='0 0 8px 0'>
      <FlexItem>
        <Flex justifyContent='space-between'>
          <FlexItem width='75%'>
            <FormElement
              feedback={error || undefined}
              feedbackVariant={error ? 'danger' : undefined}
            >
              <InputText
                placeholder={intl.formatMessage({
                  id: 'Load.MailupCommon.PlaceholderSelectEmail'
                })}
                value={email}
                onChange={handleChange}
                variant={error ? INPUT_TEXT_VARIANT_DANGER : undefined}
              />
            </FormElement>
          </FlexItem>
          <Button
            onClick={() => handleApply(email)}
            data-mu-test='select-email-apply'
            kind={BUTTON_VARIANT_PRIMARY}
            disabled={email === '' || error}
          >
            {intl.formatMessage({ id: 'Load.Common.Apply' })}
          </Button>
        </Flex>
      </FlexItem>

      {lastEmailsSelected && lastEmailsSelected.length > 0 && (
        <>
          <Flex alignItems='baseline' margin='8px 0 0 0'>
            <FlexItem margin='0 16px 0 0'>
              <StyledLabel variant={TEXT_VARIANT_LIGHT}>
                {intl.formatMessage({
                  id: 'Load.PreviewViewer.LastSelected'
                })}
              </StyledLabel>
            </FlexItem>
            {lastEmailsSelected &&
              lastEmailsSelected.map(email => (
                <FlexItem key={email.id} margin='0 8px 4px 0'>
                  <ChipCheckbox
                    checked={email.selected}
                    onChange={() => selectEmail(email)}
                    label={email.value}
                  />
                </FlexItem>
              ))}
          </Flex>
        </>
      )}
    </Flex>
  )
}

InputEmail.defaultProps = {
  lastEmails: []
}

InputEmail.propTypes = {
  lastEmails: PropTypes.arrayOf(PropTypes.object),
  searchRecipientsCallback: PropTypes.func
}
